import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AnonymousMyAccountButton from '../components/AnonymousMyAccountButton';
import MyAccountButton from '../components/MyAccountButton';
import { fetchUserSession } from 'data/account/actions/userSession';
import { showSignInModal } from 'data/account/actions/signInModal';
import URI from 'urijs';
import { generate } from '../../../routing/routes';

class MyAccountButtonContainer extends Component {
    static propTypes = {
        anonymous: PropTypes.bool,
        user: PropTypes.object,
        loading: PropTypes.bool,
        fetchUserSession: PropTypes.func,
        showSignInModal: PropTypes.func,
        signInModalVisible: PropTypes.bool
    };

    componentDidMount() {
        const url = new URI(window.location.href);
        if (url.hasQuery('login')) {
            this.props.showSignInModal();
        }
    }

    handleClick(e) {
        e.preventDefault();
        let href = null;
        const url = new URI(window.location.href);
        if(url.path() == generate("book")){
            href = generate("book");
        }

        this.props.showSignInModal(href);
    }

    render() {
        const { anonymous, user, loading, signInModalVisible, standAlone = false } = this.props;

        if (anonymous) {
            return (
                <AnonymousMyAccountButton
                    loading={loading}
                    handleClick={::this.handleClick}
                    showSignInModal={signInModalVisible}
                />
            );
        }

        return (
            <MyAccountButton
                standAlone={standAlone}
                user={user}
            />
        );
    }
}

export default connect(
    state => ({
        anonymous: null == state.account.userSession.data,
        user: state.account.userSession.data,
        loading: state.account.userSession.isFetching,
        signInModalVisible: state.account.signInModal.visible
    }),
    dispatch => bindActionCreators({ fetchUserSession, showSignInModal }, dispatch)
)(MyAccountButtonContainer);
